import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'

import { Ng2SearchPipeModule } from 'ng2-search-filter'
import { Ng2OrderModule } from 'ng2-order-pipe'
import { NgxPaginationModule } from 'ngx-pagination'

import { ViewComponent } from './view.component'
import { ViewService } from './view.service'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    Ng2OrderModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ViewComponent
  ]
})
export class ViewModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ViewModule,
      providers: [ViewService]
    }
  }
}
